export default "__VITE_ASSET__BIpipKVj__"